import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import {Link} from "react-router-dom";
import {useDispatch} from "react-redux";
import {changeMain} from "../mainSlice";

export default function ManageWorkTabs() {

    const [value, setValue] = React.useState(null);
    const [manageWorkTabs, setMangeWorkTabs] = React.useState(true);
    const dispatchData = useDispatch();

    const handleChange = (event, newValue) => {

        if (newValue === 0) {
            dispatchData(changeMain({manageWorkTabs: false, moduleTabs: true}));
        };
        if (newValue === 1) {
            dispatchData(changeMain({manageWorkTabs: false, moduleTabs: false}));
            };

    };

    const handleManage =() => {
        setMangeWorkTabs(!manageWorkTabs)
    };

    // const residualsBanner = () => {
    //     setAppBarBanner("residuals")
    // };

    return (
        <Box sx={{pt: 2, width: '100%', height: 75, bgcolor: 'background.paper' }}>
            <Tabs value={value} defaultValue={"Work"}
                // initialState={setValue("Collective Bargaining Agreements")}
                  onChange={handleChange} centered>
                <Tab  label="Maintain"
                      title="Maintain master contracts including abstracts"
                      sx={{
                          mx: 4,
                          fontSize: '1.2rem',
                          fontWeight: 500,
                          // textTransform: 'none'   // optional: prevents ALL CAPS
                      }}
                />
                />
                <Tab
                    label="Work"
                    title="Set up and process individual contracts"
                    component={Link} to={"/Work"}
                    sx={{
                        mx: 4,
                        fontSize: '1.2rem',
                        fontWeight: 500,
                        // textTransform: 'none'   // optional: prevents ALL CAPS
                    }}
                />
                {/*component={Link} to={"/Participations"}/>*/}
            </Tabs>
        </Box>
    );
}
